import { render, staticRenderFns } from "./the-order-receipt-container.vue?vue&type=template&id=31c663d7&"
import script from "./the-order-receipt-container.vue?vue&type=script&lang=js&"
export * from "./the-order-receipt-container.vue?vue&type=script&lang=js&"
import style0 from "./the-order-receipt-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports